import { FeatureSelectorLandscapeProperties } from "../../landscape/features/FeatureSelectorLandscapeProperties";
export class FeatureSelectorPortraitProperties extends FeatureSelectorLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.choice1Container.position.set(512, 1250);
        this.choice2Container.position.set(512, 700);
        this.choiceText.position.set(0, 80);
        this.pickBonusText.position.set(512, 180);
    }
}
